var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickfunnels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 85.52 71.33",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2085,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.63 0H4.89C2.207 0 0 2.207 0 4.89v61.55c0 2.683 2.207 4.89 4.89 4.89h75.74c2.683 0 4.89-2.207 4.89-4.89V4.89c0-2.683-2.207-4.89-4.89-4.89zM76 4.7c1.712 0 3.12 1.408 3.12 3.12s-1.408 3.12-3.12 3.12-3.12-1.408-3.12-3.12S74.288 4.7 76 4.7zm-11.13 0c1.712 0 3.12 1.408 3.12 3.12s-1.408 3.12-3.12 3.12-3.12-1.408-3.12-3.12 1.408-3.12 3.12-3.12zm-11.13 0c1.712 0 3.12 1.408 3.12 3.12s-1.408 3.12-3.12 3.12-3.12-1.408-3.12-3.12 1.408-3.12 3.12-3.12zM79.24 65h-73V15.15h73z",
    fill: "#394c60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 59.7a4.46 4.46 0 0 1 5-2 3.39 3.39 0 0 0 4.35-2.2 3.616 3.616 0 0 0-2-4.6 4.21 4.21 0 0 1-2.4-4.56 4.142 4.142 0 0 1 3.99-3.5 3.647 3.647 0 0 0 3.57-3.63 3.647 3.647 0 0 0-3.63-3.63h-.06a4.312 4.312 0 0 1-4.1-3.46 4.724 4.724 0 0 1 0-1.75 4.072 4.072 0 0 1 2.2-3 3.647 3.647 0 0 0 1.55-4.79 3.567 3.567 0 0 0-4.53-2.21 4.1 4.1 0 0 1-2.83.08 5.09 5.09 0 0 1-2-1.61 4.65 4.65 0 0 1-.84-3.7H10.61c7.73 4.15 15.09 12.49 15.27 23.56.2 12-6.15 21.69-15.49 26.29h18.82A4.262 4.262 0 0 1 29 59.7z",
    fill: "#3c9bd6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.53 19.95a4.252 4.252 0 0 1 1.06 5.25 4.46 4.46 0 0 1-4.65 2.73 3.4 3.4 0 0 0-4 2.84 3.616 3.616 0 0 0 2.63 4.25 4.201 4.201 0 0 1 3.07 4.14 4.141 4.141 0 0 1-3.32 4 3.643 3.643 0 0 0-3.017 3.58 3.649 3.649 0 0 0 3.632 3.632c.206 0 .412-.017.615-.052a4.311 4.311 0 0 1 4.58 2.79c.193.556.281 1.142.26 1.73a4.083 4.083 0 0 1-1.71 3.33 3.646 3.646 0 0 0-.8 5 5.096 5.096 0 0 0 2 1.8h22.26c-7.08-3.51-13.66-10.11-15.27-19.5-2.28-13.31 4-24.91 14.55-30.33H51.73a3.555 3.555 0 0 0 .8 4.81z",
    fill: "#e74f38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.94 65.7h-.65c.212.062.438.062.65 0z",
    fill: "#3c9bd6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickfunnels);
export default __webpack_public_path__ + "static/media/clickfunnels.d6dbf283aa8f34ab0c9e65b614ed9618.svg";
export { ForwardRef as ReactComponent };